import { Button, Css } from "@homebound/beam";
import { ProgressPill } from "src/components";
import { ScheduleTemplateWithMappingInfo } from "../DevelopmentScheduleCostMappingPage";

type ScheduleTemplateSelectorProps = {
  scheduleTemplates: ScheduleTemplateWithMappingInfo[];
  selectedTemplate?: ScheduleTemplateWithMappingInfo;
  handleSelection(template: ScheduleTemplateWithMappingInfo): void;
  isSummaryStep?: boolean;
};

export default function ScheduleTemplateSelector({
  scheduleTemplates,
  selectedTemplate,
  handleSelection,
  isSummaryStep = false,
}: ScheduleTemplateSelectorProps) {
  return (
    <div css={Css.bgGray100.fdc.if(isSummaryStep).bgWhite.$}>
      <div
        css={Css.df.add("flexWrap", "wrap").gapPx(24).$}
        role="radiogroup"
        aria-labelledby="cost-mapping-schedule-template-options"
      >
        {scheduleTemplates.length === 0 && (
          <span>There aren't any schedule templates associated to this development that can be mapped.</span>
        )}
        {scheduleTemplates.map((scheduleTemplate) => {
          const isSelected = selectedTemplate?.id === scheduleTemplate.id;

          return (
            <div
              role="radio"
              tabIndex={0}
              aria-checked={isSelected}
              aria-label={`${scheduleTemplate.stage}-template-${scheduleTemplate.name}`}
              onKeyPress={({ key }) => {
                key === "Enter" && !isSummaryStep && handleSelection(scheduleTemplate);
              }}
              onClick={() => !isSummaryStep && handleSelection(scheduleTemplate)}
              key={`schedule-template-card-${scheduleTemplate.id}`}
              css={{
                ...Css.df.fdc.bgWhite.jcsb.br8.px2.pt2.wPx(300).mhPx(156).pb("22px").bw1.bcGray200.$,
                ...(isSummaryStep ? Css.ba.$ : Css.cursorPointer.$),
                ...(!isSummaryStep && !isSelected ? Css.onHover.bshHover.$ : {}),
                ...(isSelected ? Css.ba.bcBlue700.bw2.$ : {}),
              }}
              data-testid="scheduleTemplateCard"
            >
              <div>
                <div css={Css.sm.pb1.gray700.if(isSummaryStep).xs2.$}>{scheduleTemplate.stageDetail.name}</div>
                <div css={Css.md.pb2.gray900.$}>{scheduleTemplate.name}</div>
              </div>
              <ProgressPill
                stacked
                fullWidth
                bottomLabel
                text={`${scheduleTemplate.mapped}/${scheduleTemplate.total} mapped items ${
                  scheduleTemplate.total > 0 && scheduleTemplate.mapped >= scheduleTemplate.total ? "🎉" : ""
                }`}
                changeColorOnCompleted
                progress={(scheduleTemplate.mapped / scheduleTemplate.total) * 100}
                hideProgress
              />
              {isSummaryStep && (
                <div css={Css.df.jcc.mt4.$}>
                  <Button
                    label="Continue Mapping"
                    variant="secondary"
                    onClick={() => handleSelection(scheduleTemplate)}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
